<template lang="">
  <div class="team-list-card">
    <section class="team-list">
      <div class="d-flex gap-05 align-items-center justify-content-center">
        <TeamLogo :team="type === 'home' ? homeTeam : awayTeam" :small="true" />
        <h5 class="text-center c-white team-name">{{ upperCase(teamName) }}</h5>
      </div>
      <div class="player-list" v-if="players && players.length">
        <article class="player" v-for="player in players" :key="player._id">
          <img :src="presentation.showLogo && player.imgUrl ? player.imgUrl : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt9KcSYpVsC4b1o_3v2QgaIyo3NxOk6v9eoQ&usqp=CAU'"   alt="" class="player-avatar">
          <div class="d-grid">
            <h3 class="c-white player-name">{{ get(player, 'isPublic', true) ? player.firstName + ' ' + player.lastName : 'Team Player' }}</h3>
            <span class="c-darkgray position">{{ get(player, 'position.name') }}</span>
          </div>
          <div class="badge-area">
            <ion-badge class="badge" color="danger" v-if="player.hasImport">
              Im
            </ion-badge>
            <ion-badge class="badge" color="danger" v-if="player.hasDispensation">
              D
            </ion-badge>
          </div>
          <h3 class="c-white shirt-no text-right">{{ player.shirtNum }}</h3>
        </article>
      </div>
      <div class="no-players" v-else>
        <span class="text-center no-players-text">No Team List Submitted</span>
      </div>
    </section>
  </div>
</template>
    
<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import TeamLogo from '../../views/matches/base/team-logo.vue'
    
export default {
  name: 'TeamFormCard',
  // props: {
  //   match: {
  //     type: Object,
  //     required: true
  //   }
  // },
  components: {
    TeamLogo,
  },
  data() {
    return {
      moment,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    }
  },
  mounted() {
    console.log(this.players);
  },
  computed: {
    ...mapGetters('match', ['homeTeamList', 'awayTeamList', 'homeTeam', 'awayTeam', 'competition']),
    players() {
      const { type } = this;
      if (type === 'home') return this.homeTeamList;
      return this.awayTeamList;
    },
    teamName() {
      const { type } = this;
      if (type === 'home') return this.homeTeam?.name;
      return this.awayTeam?.name;
    },
    presentation() {
      return this.$store.getters['national/presentation'];
    },
  },  
  methods: {
    checkHasExemptionImport(member) {
      const competition = this.competition;
      const exemptionList = _.get(member, 'meta.exemptionList', []);
      return _.find((exemptionList), (e) => {
        const mapCompetitionIds = _.map(_.get(e, 'competitions', []), '_id');
        return e.type === 'import' && e.flag === true && _.includes(mapCompetitionIds, competition._id);
      });
    },
    checkHasExemptionDispensation(member) {
      const competition = this.competition;
      const exemptionList = _.get(member, 'meta.exemptionList', []);
      return _.find((exemptionList), (e) => {
        const mapCompetitionIds = _.map(_.get(e, 'competitions', []), '_id');
        return e.type === 'dispensation' && e.flag === true && _.includes(mapCompetitionIds, competition._id);
      });
    },
    formatDateTime(timestamp) {
      const isTomorrow = moment().add(1, 'day').isSame(timestamp, 'day');
      const isToday = moment().isSame(timestamp, 'day');
      const time = moment(timestamp).format('h:mm A');
      if (isToday) {
        return moment(timestamp).format('h:mm A');
      } else if (isTomorrow) {
        return `Tomorrow ${time}`;
      } else {
        return moment(timestamp).format('ddd, MMM D');
      }
    }
  }
}
</script>
    
<style lang="scss" scoped>

  .team-list-card {
    background: #171717;
    border-radius: 24px;
    padding: 1rem 1.5rem;
    // margin: 1rem 1rem;
    margin-bottom: 1rem;
    max-width: 768px;
    @media (min-width: 768px) {
      min-width: 728px;
    }
    
    .team-list {
      
      .no-players { 
        display: flex; 
        justify-content: center; 
        margin-top: 1rem;
      }
      .no-players-text {
        letter-spacing: -.05rem;
        color: #8e8d8d;
      }

    }

    .player-list {
      margin-top: 1.75rem;
      margin-bottom: 1.5rem;
      display: grid;
      gap: 1.5rem;
    }

    .player {
      display: grid;
      align-items: center;
      grid-template-columns: 2rem 1fr 3rem 3rem;
      gap: 0.5rem;

      .player-avatar {
        width: 2rem;
        height: 2rem;
        border-radius: 200px;
        object-fit: cover;
      }

      .player-name {
        font-family: 'BrownStd-Regular';
        font-size: 0.925rem;
        margin: 0;
      }

      .position {
        text-transform: uppercase;
        font-family: 'BrownStd-Bold';
        font-size: 0.75rem;
      }

      .shirt-no {
        margin: 0;
        margin-bottom: -2px;
        font-size: 1.5rem;
      }
      
      .badge {
        // background: #c52828;
        background: #c52828;
        padding: 0.2rem 0.8rem;
        padding-top: 0.3rem;
        border-radius: 25%;
        font-size: small;
        margin-right: 10px;
      }

      .end-area {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0.75rem;
      }
    }

    .team-name {
      font-family: 'BrownStd-Bold';
      letter-spacing: -0.05rem;
      color: #F0F2F5;
      font-size: 1rem;
    }
  }

  .bold-title {
    max-width: none;
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
    background: #171717 !important;
    &:hover {
      background: hsl(225, 6%, 14%) !important;
    }
    margin-inline: 1.5rem;
    margin-bottom: 1rem;

    .venue {
      letter-spacing: -0.01rem;
    }

    padding: 0.5rem;
  }

ion-badge {
  border-radius: 200px;
  height: 1.75rem;
}

.date-time {
  margin-top: 0.5rem;
  margin-bottom: -0.25rem;
}

.team-name {
  font-family: 'BrownStd-Regular';
  color: #ebebeb;
}

.score-text {
  font-size: 1.3rem;
}


.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

.badge{
  display:flex;
  text-align:end;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 5px;
}

.badge-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 5px;
  width: 60px;
} 
</style>